// 全局常用UI组件库 begin
import VTree from "@/components/common/ui/vTree/Tree";
import AddFile from "@/components/common/ui/AddFile";
import AreaInput from "@/components/common/ui/AreaInput";
import Checkbox from "@/components/common/ui/Checkbox";
import Confirm from "@/components/common/ui/Confirm";
import DashLine from "@/components/common/ui/DashLine";
import FunctionButton from "@/components/common/ui/FunctionButton";
import InputPhone from "@/components/common/ui/InputPhone";
import InputText from "@/components/common/ui/InputText";
import Label from "@/components/common/ui/Label";
import Loading from "@/components/common/ui/Loading";
import Logo from "@/components/common/ui/Logo";
import NoResult from "@/components/common/ui/NoResult";
import OnOff from "@/components/common/ui/OnOff";
import Pagination from "@/components/common/ui/Pagination";
import Panel from "@/components/common/ui/Panel";
import Radio from "@/components/common/ui/Radio";
import RadioGroup from "@/components/common/ui/RadioGroup";
import Select from "@/components/common/ui/Select";
import StatusIco from "@/components/common/ui/StatusIco";
import TagBox from "@/components/common/ui/TagBox";
import TagForm from "@/components/common/ui/TagForm";
import VerificationCode from "@/components/common/ui/VerificationCode";
import WindowForAlert from "@/components/common/ui/WindowForAlert";
import WindowForNew from "@/components/common/ui/WindowForNew";
import WindowForSetting from "@/components/common/ui/WindowForSetting";
import WindowForView from "@/components/common/ui/WindowForView";
import SvgIcon from "@/components/common/ui/SvgIcon.vue";
// 全局UI组件库 end

const install = (Vue, opts = {}) => {
	// 导入全局UI组件 begin
	const components = {
		VTree,
		AddFile,
		AreaInput,
		Checkbox,
		Confirm,
		DashLine,
		FunctionButton,
		InputPhone,
		InputText,
		Label,
		Loading,
		Logo,
		NoResult,
		OnOff,
		Pagination,
		Panel,
		Radio,
		RadioGroup,
		Select,
		StatusIco,
		TagBox,
		TagForm,
		VerificationCode,
		WindowForAlert,
		WindowForNew,
		WindowForSetting,
		WindowForView,
		Icon: SvgIcon
	};
	Object.keys(components).forEach(key => {
		Vue.component(key, components[key]);
	});
	// 导入全局组件 end
};

export default install;



// WEBPACK FOOTER //
// ./src/plugins/index.js